(function () {
  function computeMessage(inStock, cutoffHour) {
    var warehouse = "Leays Warehouse";
    if (!inStock) return "Currently out of stock for delivery.";

    var now = new Date();
    var today = now.getHours() < Number(cutoffHour || 14);
    return today
      ? "In stock — ships today from " + warehouse + "."
      : "In stock — ships tomorrow from " + warehouse + ".";
  }

  function update() {
    var root = document.getElementById("ship-from-warehouse");
    if (!root) return;

    var cutoff = root.dataset.cutoffHour || "14";
    var msgEl = root.querySelector(".ShipMsg");
    if (!msgEl) return;

    // Track last variant availability
    var inStock = window.__lastSelectedVariantAvailable;
    if (typeof inStock !== "boolean") {
      inStock = /In stock/i.test(msgEl.textContent);
    }

    msgEl.textContent = computeMessage(inStock, cutoff);
    msgEl.classList.toggle("is-oos", !inStock);
  }

  function onVariantChange(e) {
    var variant = e && e.detail && (e.detail.variant || e.detail.selectedVariant);
    if (variant) window.__lastSelectedVariantAvailable = !!variant.available;
    update();
  }

  document.addEventListener("DOMContentLoaded", update);
  document.addEventListener("variant:change", onVariantChange);
  document.addEventListener("product:variant-change", onVariantChange);
})();
